/**
 * Created by fkurzawa on 19.03.18.
 */
import ApiConfig from "./api.config";

const apiUrl = `${ApiConfig.getEntryPoint()}files`;

export const getFileThumbnailUrl = (fileId: number) =>
  `${apiUrl}/${fileId}/thumbnail`;
